import type { TI18n } from '@muse/i18n'
import type { TNavEntryView } from '../components/types'
import { mapNavEntries } from './mapNavEntries'
import { navLinkClick, navSectionClick, type TNavPlacement } from './navAnalytics'

export const buildNavEntries = (t: TI18n['t'], placement: TNavPlacement): TNavEntryView[] =>
    mapNavEntries({
        label: source => t(source.labelKey),
        description: link => (link.descriptionKey ? t(link.descriptionKey) : undefined),
        linkClick: link => navLinkClick(placement, link.analytics),
        sectionClick: dropdown => navSectionClick(placement, dropdown.analytics),
    })
